// Single source of truth for the password rules the auth service enforces.
// The signup form, the admin "New User" form and the admin password reset all
// validate against this, so an operator never gets to submit a password the
// backend is going to reject.
// 12+ chars, at least one lower, upper, digit and symbol.
export const PASSWORD_POLICY_REGEX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{12,}$/;

export function isValidPassword(password) {
  return typeof password === "string" && PASSWORD_POLICY_REGEX.test(password);
}
